import { BoxGeometry, Mesh, MeshStandardMaterial, Quaternion, Vector3 } from 'three';
import { Prop } from '../../../entities/Prop.js';
import { GROUP, MASK } from '../../../physics/groups.js';

const UP = new Vector3(0, 1, 0);

export function yawQuaternion(yaw = 0) {
  return new Quaternion().setFromAxisAngle(UP, yaw);
}

export function addStaticCollider(
  level,
  { x, y = 0, z, width, height, depth, yaw = 0 },
) {
  const prop = new Prop({
    physics: level.world.physics,
    mesh: null,
    shape: { type: 'box', size: [width, height, depth] },
    mass: 0,
    position: [x, y, z],
    quaternion: yawQuaternion(yaw).toArray(),
    friction: 0.9,
    restitution: 0,
    group: GROUP.LEVEL,
    mask: MASK.LEVEL,
    userData: { type: 'level-collider' },
  });
  level.register(prop);
  return prop;
}

/**
 * Add a box mesh without turning it into a physics body. Geometry is shared
 * between callers when a cached geometry is supplied.
 */
export function addBoxMesh(parent, {
  x = 0,
  y = 0,
  z = 0,
  width = 1,
  height = 1,
  depth = 1,
  yaw = 0,
  material,
  castShadow = true,
  receiveShadow = true,
  geometry = null,
}) {
  const mesh = new Mesh(
    geometry ?? new BoxGeometry(width, height, depth),
    material,
  );
  if (!geometry) {
    // Explicit sizes above already baked into the geometry.
  } else {
    mesh.scale.set(width, height, depth);
  }
  mesh.position.set(x, y, z);
  mesh.rotation.y = yaw;
  mesh.castShadow = castShadow;
  mesh.receiveShadow = receiveShadow;
  parent.add(mesh);
  return mesh;
}

export function createBasicMaterial(color, options = {}) {
  return new MeshStandardMaterial({ color, roughness: 0.9, ...options });
}


/**
 * Register an invisible static collision mesh that only the player vehicle
 * sees. Used to close the road corridor without affecting the chase camera,
 * ground probes or scripted traffic.
 */
export function addVehicleBoundary(level, { geometry, name = 'vehicle-boundary' }) {
  const prop = new Prop({
    physics: level.world.physics,
    mesh: null,
    shape: { type: 'trimesh', geometry },
    mass: 0,
    position: [0, 0, 0],
    quaternion: [0, 0, 0, 1],
    friction: 0,
    restitution: 0,
    group: GROUP.BOUNDARY,
    mask: GROUP.VEHICLE,
    userData: { type: 'vehicle-boundary', name },
  });
  level.register(prop);
  return prop;
}
